import React from "react"
import { Alert } from "react-bootstrap"

export default function ProcessesStatus({ error, running, runningText, success, successText}) {

  return error 
  ? <Alert bsStyle="danger"><strong>{ error }</strong></Alert>
  : running 
  ? <Alert bsStyle="info">
      <strong>{ runningText ? runningText : 'Running, please wait..' } </strong>
    </Alert>
  : success 
  ? <Alert bsStyle="success">
      <strong>{ successText ? successText : 'Completed successfully' }</strong>
    </Alert>
  : null
}



// WEBPACK FOOTER //
// ./src/components/fragments/ProcessesStatus.js